import { atom } from "jotai";

export const diagnosisLoading = atom(false);
